interface useDialCodeType {
  getDialCode: (countryIso: string) => string;
  dialCodes: Record<string, string>;
}

const useDialCode = (): useDialCodeType => {
  const dialCodes: Record<string, string> = {
    BR: "+55",
    CO: "+57",
    EC: "+593",
    GT: "+502",
    ID: "+62",
    IN: "+91",
    MX: "+52",
    PA: "+507",
    PE: "+51",
    PH: "+63",
    US: "+1",
    ZA: "+27",
  };

  const getDialCode = (countryIso: string): string =>
    dialCodes[countryIso?.toUpperCase()] || "+1";

  return {
    getDialCode,
    dialCodes,
  };
};

export default useDialCode;
